<template>
    <div class="shop-container">
        <transition>
            <shopify v-if="showOrder" :order="order" />
        </transition>
    </div>
</template>

<style lang="scss" scoped>
.shop-container {
    height: 100vh;
    width: 100vw;
}
</style>

<script>
import io from "socket.io-client";
import Shopify from "@/components/custom/maddy/Shopify";
import orderCreate from "@/assets/custom/maddy/Sounds/order_create_1.mp3";
import orderCreate2 from "@/assets/custom/maddy/Sounds/order_create_2.mp3";
import orderCreate3 from "@/assets/custom/maddy/Sounds/order_create_3.mp3";
import { sample } from "lodash";

export default {
    name: "MaddyShopify",
    data: () => ({
        socket: null,
        product: null,
        showOrder: false,
        order: {
            products: undefined,
        },
        notificationSounds: [orderCreate, orderCreate2, orderCreate3],
    }),
    methods: {
        playSound(sound) {
            if (sound) {
                const audio = new Audio(sound);
                audio.play();
            }
        },
        showShopify(data) {
            const self = this;
            this.product = data;
            this.showOrder = true;
            this.order.products = data.products;

            const sound = sample(this.notificationSounds);
            this.playSound(sound);

            setTimeout(function() {
                self.showOrder = false;
                self.order = {
                    products: undefined,
                };
            }, 15000);
        },
    },
    mounted() {
        let socketURL;

        if (process.env.NODE_ENV === "development") {
            socketURL = "localhost:8042";
        } else {
            socketURL = "https://merubot.madeleineink.com";
        }

        this.socket = io(socketURL, {
            transports: ["websocket", "xhr-pulling"],
        });

        this.socket.on("shopify", data => {
            this.showShopify(data);
        });
    },
    components: { Shopify },
};
</script>
